import { render, staticRenderFns } from "./guest_huifang.vue?vue&type=template&id=16027cc2&scoped=true"
import script from "./guest_huifang.vue?vue&type=script&lang=js"
export * from "./guest_huifang.vue?vue&type=script&lang=js"
import style0 from "./guest_huifang.vue?vue&type=style&index=0&id=16027cc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16027cc2",
  null
  
)

export default component.exports